import {
	madnes_add_group,
	madnes_add_img,
	madnes_add_to_group,
	madnes_get_dimension_wi,
	madnes_remove_sprite,
	madnes_set_img_center,
	madnes_set_pos,
	madnes_set_pos_y,
	madnes_set_scale,
	madnes_set_visible,
	madnes_add_sprite,
	madnes_sprite_set_frame_name
} from "../framework/src/engine/madnes/madnes_object";
import {server_config, he_scale, multi, wi_scale, picture_convert} from "../framework/src/engine/madnes/madnes_variables";
import {
	madnes_add_bitmap_float, madnes_add_bitmap_text,
	madnes_add_text, madnes_set_bitmap_float,
	madnes_set_text_shadow
} from "../framework/src/engine/madnes/madnes_text";
import {bet, madnes_get_json} from "../framework/src/engine/madnes/madnes";

var info_pos = 1;

var info_pos_count = 2;

var slides = {};

var leftCol = 590;
var rightCol = 1024;

var infotext_positions = {
	"info_symbol_Joker" : { x: leftCol, y: 345 },
	"info_symbol_Bar" : { x: leftCol, y: 441 },
	"info_symbol_Star" : { x: leftCol, y: 537 },
	"info_symbol_Melon" : { x: leftCol, y: 633 },
	"info_symbol_Bell" : { x: rightCol, y: 337 },
	"info_symbol_Plum" : { x: rightCol, y: 413 },
	"info_symbol_Orange" : { x: rightCol, y: 489 },
	"info_symbol_Dollar" : { x: rightCol, y: 565 },
	"info_symbol_Cherry" : { x: rightCol, y: 641 }
};

export function j27_infomenu_init()
{
	for(var i = 1; i <= info_pos_count; i++)
	{
		madnes_add_group("wintable_group_" + i);

		madnes_add_img("wintable_" + i, "wintable_" + i, 0, 0);
		madnes_set_scale("wintable_" + i, wi_scale * multi, he_scale * multi);

		madnes_add_to_group("wintable_group_" + i, "wintable_" + i);
		madnes_set_pos("wintable_group_" + i, 0, 0);
		madnes_set_visible("wintable_group_" + i, false);
	}

	madnes_add_sprite("scatter_dice", "symbols_atlas", 1000, 500);
	madnes_sprite_set_frame_name("scatter_dice", picture_convert[6]);
	madnes_set_scale("scatter_dice", 0.50, 0.50);
	madnes_add_to_group("wintable_group_2", "scatter_dice");

	/*var style = {
		'font': '40px Arial',
		'align': 'right',
		'fontWeight': 'bold',
		'stroke': '#000',
		'strokeThickness': 5,
		'fill': '#FFF',
	};*/

	/*madnes_add_graphics("test", leftCol, 345);
	madnes_graphics_set_line_style("test", 1, 0xFF0000);
	madnes_graphics_begin_fill("test", 0xFF700B);
	madnes_graphics_draw_rectangle("test", 0, 0, -170, 50);
	madnes_add_to_group("wintable_group_1", "test");*/

	madnes_add_bitmap_float("info_symbol_Joker", "font_wintable", infotext_positions["info_symbol_Joker"].x, infotext_positions["info_symbol_Joker"].y, "", 80, 170);
	madnes_set_img_center("info_symbol_Joker", 1, 1);


	madnes_add_bitmap_float("info_symbol_Bar", "font_wintable", infotext_positions["info_symbol_Bar"].x, infotext_positions["info_symbol_Bar"].y, "", 80, 170);
	madnes_set_img_center("info_symbol_Bar", 1, 1);

	madnes_add_bitmap_float("info_symbol_Star", "font_wintable", infotext_positions["info_symbol_Star"].x, infotext_positions["info_symbol_Star"].y, "", 80, 170);
	madnes_set_img_center("info_symbol_Star", 1, 1);

	madnes_add_bitmap_float("info_symbol_Melon", "font_wintable", infotext_positions["info_symbol_Melon"].x, infotext_positions["info_symbol_Melon"].y, "", 80, 170);
	madnes_set_img_center("info_symbol_Melon", 1, 1);


	madnes_add_bitmap_float("info_symbol_Bell", "font_wintable", infotext_positions["info_symbol_Bell"].x, infotext_positions["info_symbol_Bell"].y, "", 80, 170);
	madnes_set_img_center("info_symbol_Bell", 1, 1);

	madnes_add_bitmap_float("info_symbol_Plum", "font_wintable", infotext_positions["info_symbol_Plum"].x, infotext_positions["info_symbol_Plum"].y, "", 80, 170);
	madnes_set_img_center('info_symbol_Plum', 1, 1);

	madnes_add_bitmap_float('info_symbol_Orange', "font_wintable", infotext_positions["info_symbol_Orange"].x, infotext_positions["info_symbol_Orange"].y, "", 80, 170);
	madnes_set_img_center('info_symbol_Orange', 1, 1);

	madnes_add_bitmap_float('info_symbol_Dollar', "font_wintable", infotext_positions["info_symbol_Dollar"].x, infotext_positions["info_symbol_Dollar"].y, "", 80, 170);
	madnes_set_img_center('info_symbol_Dollar', 1, 1);

	madnes_add_bitmap_float('info_symbol_Cherry', "font_wintable", infotext_positions["info_symbol_Cherry"].x, infotext_positions["info_symbol_Cherry"].y, "", 80, 170);
	madnes_set_img_center('info_symbol_Cherry', 1, 1);

	madnes_add_to_group("wintable_group_1", "info_symbol_Joker");
	madnes_add_to_group("wintable_group_1", "info_symbol_Bar");
	madnes_add_to_group("wintable_group_1", "info_symbol_Star");
	madnes_add_to_group("wintable_group_1", "info_symbol_Melon");
	madnes_add_to_group("wintable_group_1", "info_symbol_Bell");
	madnes_add_to_group("wintable_group_1", "info_symbol_Plum");
	madnes_add_to_group("wintable_group_1", "info_symbol_Orange");
	madnes_add_to_group("wintable_group_1", "info_symbol_Dollar");
	madnes_add_to_group("wintable_group_1", "info_symbol_Cherry");

	var infotext = madnes_get_json("infotext");

	for(var i in infotext)
	{
		var x = infotext[i]["position"][0];
		var y = infotext[i]["position"][1];

		var page = infotext[i]["page"];
		var lineHeight0 = infotext[i]["title"]["lineHeight"];
		var lineHeight1 = infotext[i]["lineHeight"];

		var styleTitle = {
			"font": "30px Arial",
			"fill": "#fff000",
			"fontWeight": "",
		};
		var styleBody = {
			"font": "30px Arial",
			"fill": "#ffffff",
			"fontWeight": "",
		};

		if(infotext[i]["fontSize"] && infotext[i]["font"]) {
			styleTitle["font"] = infotext[i]["fontSize"] + "px " + infotext[i]["font"];
			styleBody["font"] = infotext[i]["fontSize"] + "px " + infotext[i]["font"];
		}

		setStroke(styleTitle, infotext[i]["title"]);
		setStroke(styleBody, infotext[i]["body"]);

		if(infotext[i]["title"]["align"]) {
			styleTitle["align"] = infotext[i]["title"]["align"];
		}

		if(infotext[i]["title"]["color"]) {
			styleTitle["fill"] = infotext[i]["title"]["color"];
		}

		if(infotext[i]["body"]["color"]) {
			styleBody["fill"] = infotext[i]["body"]["color"];
		}

		if(infotext[i]["title"]["bold"]) {
			styleTitle["fontWeight"] = "bold";
		}

		if(infotext[i]["body"]["bold"]) {
			styleBody["fontWeight"] = "bold";
		}

		var line0 = 0;
		var line1 = 0;

		for(var j in infotext[i]["title"]["content"])
		{
			var text = infotext[i]["title"]["content"][j];
			var textName = "info_header_" + i + "_"  + j + "_" + line0;
			var groupName = "wintable_group_" + ( page * 1 + 1 );

			madnes_add_text(textName, x, y + line0 * lineHeight0, text, styleTitle);
			madnes_add_to_group(groupName, textName);

			setTextShadow(infotext[i]["title"], textName);
			line0++;
		}

		for(var j in infotext[i]["body"]["content"])
		{
			var text = infotext[i]["body"]["content"][j];
			var textName = "info_body_" + i + "_"  + j + "_" + line1;
			var groupName = "wintable_group_" + ( page * 1 + 1 );

			madnes_add_text(textName, x, y + line0 * lineHeight0 + line1 * lineHeight1, text, styleBody);
			madnes_add_to_group(groupName, textName);

			//setTextShadow(infotext[i]["body"], textName);
			line1++;
		}
	}

	j27_infomenu_update();
}

function setTextShadow(infoText, textName) {
	if(infoText["shadow"]) {
		var shadowOffsetX = infoText["shadow"]["offsetX"];
		var shadowOffsetY = infoText["shadow"]["offsetY"];
		var shadowColor = infoText["shadow"]["color"];
		var shadowBlur = infoText["shadow"]["blur"];
		var shadowStroke = infoText["shadow"]["shadowStroke"];
		var shadowFill = infoText["shadow"]["shadowFill"];

		//console.log(textName, shadowOffsetX, shadowOffsetY, shadowColor, shadowBlur);

		shadowOffsetX /= multi;
		shadowOffsetY /= multi;
		shadowBlur /= multi;
		shadowBlur /= multi;

		madnes_set_text_shadow(textName, shadowOffsetX, shadowOffsetY, shadowColor, shadowBlur, shadowStroke, shadowFill);
	}
}

function setStroke(style, infoText) {
	if(infoText["strokeThickness"] && infoText["strokeThickness"] * 1 > 1) {
		style["strokeThickness"] = infoText["strokeThickness"];
	}

	if(infoText["strokeColor"]) {
		style["strokeColor"] = infoText["strokeColor"];
	}
}

function set_info_sums()
{

	//madnes_set_bitmap_float("info_symbol_Joker", "600000", 170);
	var offset = get_bitmap_offset(server_config.logic.symbols[8]['factors'][2] * bet, 170);
	/*madnes_set_pos_y("info_symbol_Joker", infotext_positions["info_symbol_Joker"].y + offset * -1);*/

	for(var symIndex in server_config.logic.symbols) {
		var factors = server_config.logic.symbols[symIndex]['factors'];
		var symbName = server_config.logic.symbols[symIndex]['name'];
		var val = bet * factors[2];

		madnes_set_bitmap_float("info_" + symbName, val, offset > 0 ? 1 : 170);
		madnes_set_pos_y("info_" + symbName, infotext_positions["info_" + symbName].y + offset * -1);
	}
}

export var openinfo = false;

export function j27_infomenu_open()
{
	madnes_set_visible("wintable_group_" + info_pos, true);
	madnes_set_pos("wintable_group_" + info_pos, 0, 0);
	openinfo = true;
}

export function j27_infomenu_close()
{
	for(var i = 1; i <= info_pos_count; i++)
	{
		madnes_set_visible("wintable_group_" + i, false);
	}

	openinfo = false;
}

function infomenu_click()
{
	//madnes_audio_play("bet");
	j27_infomenu_update();
}

export function j27_infomenu_update()
{
	setTimeout(function() {
		set_info_sums();
	}, 100);

}

export function j27_infomenu_left()
{
    if(!openinfo) return;
	menu_swipe(1);
}

export function j27_infomenu_right()
{
	if(!openinfo) return;
	menu_swipe(-1);
}

function menu_swipe(dir)
{
	var info_pos2 = info_pos;
	info_pos2 = info_pos2 * 1 + dir * -1;

	if(info_pos2 <= 0)
	{
		info_pos2 = info_pos_count;
	}

	if(info_pos2 > info_pos_count)
	{
		info_pos2 = 1;
	}

	madnes_set_visible("wintable_group_" + info_pos, false);
	madnes_set_visible("wintable_group_" + info_pos2, true);

	info_pos = info_pos2;
}

function get_bitmap_offset(text, max_width)
{
	var offs = 0;

	madnes_add_bitmap_text("infotext_tmp", "font_wintable", 0, 0, text, 80);

	if(madnes_get_dimension_wi("infotext_tmp") > max_width) {
		offs = 10;
	}

	madnes_remove_sprite("infotext_tmp");

	return offs;
}